require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./restaurants-commerces-et-htels-1-3.json") })
        }
      }, "path---restaurants-commerces-et-htels-1-3");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---restaurants-commerces-et-htels-1-3!./.cache/json/restaurants-commerces-et-htels-1-3.json
// module id = 550
// module chunks = 231608221292675